import { render, staticRenderFns } from "./ArticleListEdit.vue?vue&type=template&id=446aa2ad&scoped=true"
import script from "./ArticleListEdit.vue?vue&type=script&lang=js"
export * from "./ArticleListEdit.vue?vue&type=script&lang=js"
import style0 from "./ArticleListEdit.vue?vue&type=style&index=0&id=446aa2ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446aa2ad",
  null
  
)

export default component.exports